/* --------------------------------------------------------------------------
	Alert - WordPress / Drupal
-------------------------------------------------------------------------- */

	"use strict";

	var $ = jQuery;
	import "./swap-plugin.js";

	var $Alert,
		$CloseButton,
		$OpenButton,
		$SkipLink,
		AlertID,
		Time;

	var isAlertOpen = false;

	function initAjaxAlert() {
		// AlertURL is a global from functions.php
		if (typeof AlertURL === "undefined") {
			return;
		}

		$SkipLink = $(".js-skip-alert").hide();

		$.ajax(AlertURL).done(function(response) {
			if (!response) {
				return;
			}

			$(".js-alert-wrapper").html(response);

			// This HTML loaded after swap.js so needs to call swap() again.
			$Alert = $(".js-alert");
			$Alert.find(".js-swap").swap();
			$SkipLink.show();
			$CloseButton = $(".js-alert-close");
			$OpenButton = $(".js-alert-open");
			AlertID = $Alert.data("alert-id");
			Time = $Alert.data("time");

			// Not hidden, show it and hide the open button
			if (isAlertVisible(AlertID, Time)) {
				alertOpen();
				// Should it focus? I assume I'd be annoying to
				// hear the alert every visit to the site.
			} else {
				alertClose();

				// Cover up the dismiss animation?
				$Alert.hide();
				$CloseButton.swap("activate");

				setTimeout(function() {
					$Alert.show();
				}, 250);
			}

			$CloseButton.on("click", onCloseClick);
			$SkipLink.on("click", onOpenClick);
			$OpenButton.on("click", onOpenClick);
		});
	}

	//
	// Store alert-dismissed = {"post_id": "modified_time", ...}
	//
	function loadState() {
		try {
			var x = window.localStorage.getItem("dimissed-alerts");
			if (x) {
				return JSON.parse(x);
			}
		} catch (e) {
			// localStorage or JSON threw. Continue with an empty state.
			console.log(e);
		}
		return {};
	}

	function saveState(state) {
		window.localStorage.setItem("dimissed-alerts", JSON.stringify(state));
	}

	function isAlertVisible(id, time) {
		var dismissed = loadState();
		id = ""+id;
		time = 0+time;
		return dismissed[id] !== time;
	}

	function rearmAlert(id) {
		var dismissed = loadState();
		id = "" + id;
		dismissed[id] = 0;
		saveState(dismissed);
	}

	function dismissAlert(id, time) {
		var dismissed = loadState();
		id = "" + id;
		time = 0 + time;
		dismissed[id] = time;
		saveState(dismissed);
	}

	function updateAlertHeight() {
		var h = isAlertOpen ? $Alert.height() : 0;

		$('.cc-window.cc-bottom').css(
			'bottom',
			`${h}px`
		);
	}
	
	function alertClose() {
		$Alert.attr("aria-hidden", "true");
		$Alert.find("a, button").attr("tabindex", "-1");
		isAlertOpen = false;
		updateAlertHeight();
	}

	function alertOpen() {
		$Alert.attr("aria-hidden", "false");
		$Alert.find("a, button").removeAttr("tabindex");
		isAlertOpen = true;
		updateAlertHeight();
	}

	function onCloseClick() {
		dismissAlert(AlertID, Time);
		alertClose();
		$CloseButton.blur();
	}

	function onOpenClick() {
		rearmAlert(AlertID);
		alertOpen();

		// Move focus to the alert once the the animation
		// is done.
		$Alert.one('transitionend', function () {
			$Alert.focus();
		});
	}

	$(window).on('resize', function() {
        updateAlertHeight();
    });

	$(initAjaxAlert);
